module.exports = __webpack_public_path__ + "static/flags/ET-b2327e58ddec9f09a988e4480d1188a0.gif";